import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root',
})

export class CookiesService {

  setCookies(name: string, value: string, days: number): void {
    document.cookie = `${name}=${value}; max-age=${days * 24 * 6000}; secure=true; samesite=lax; path=/`;
  }

  getCookies(name: string): string | null {
    const matches: RegExpMatchArray | null = document.cookie.match(new RegExp(
      '(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'
    ));
    return matches ? decodeURIComponent(matches[1]) : null;
  }

  deleteCookie(name: string): void {
    this.setCookies(name, '', -1);
  }

}
